export default {
	"foreuserOrganization": {
		"addUser": "新增人员",
		"addRoles": "角色添加"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/foreuserOrganization/foreuserOrganization.js